module.exports = __webpack_public_path__ + "static/media/mildred_img_3.c1a3fc7c.jpg";